/**
 * Actor-id display helper for the runtime-config surface (AUT-131,
 * locked decision): render `lastChangedBy` / `changedBy` AS-IS — a raw
 * admin id, truncated — with NO backend name resolution (out of scope).
 *
 * Mirrors the truncation shape used elsewhere (`shortId` in refunds):
 * a long uuid `admin-7700-…-000000000000` collapses to `admin-77…000`.
 * `null` (seed / system write) returns `null` so the caller renders the
 * em-dash placeholder via i18n.
 */
export const shortActor = (id: string | null): string | null => {
  if (id === null) return null;
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};
